import type { FC, ReactNode } from 'react';
import { Typography } from '@interstate/components/Typography';
import { ResultField } from './search.styles';

export interface LabelledFieldProps {
    label: string;
    children: ReactNode;
}

/** A result field rendered as "Label: value". */
const LabelledField: FC<LabelledFieldProps> = ({ label, children }) => (
    <ResultField>
        <Typography variant="body-sm" sx={{ color: '#6b7280' }}>
            {label}:{' '}
        </Typography>
        {children}
    </ResultField>
);

export default LabelledField;
